import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import { atQuery } from '../../scripts/components/mediaQueries';

$(function () {
  let imagesDesktop = $('.product-single .zoom__img');
  let imagesMobile = $('.product-gallery--mobile .zoom__img');

  document.querySelectorAll('.pswp').forEach(pswpElement => {
    initGallery(imagesDesktop, pswpElement);
    initGallery(imagesMobile, pswpElement);
  });
});

function initGallery(images, pswpElement) {
  let items = [];
  let gallery;

  images.each(function () {
    let img = $(this);
    let aspectRatio = parseFloat(img.attr('data-aspectratio'));
    let zoomImg = img.attr('data-zoom-src');
    if (zoomImg) {
      items.push({
        src: zoomImg,
        w: 2000 * aspectRatio,
        h: 2000
      });

      img.on('click', function (e) {
        if (window.PREVENT_ZOOM) return;
        let index = images.index(this);

        let options = {
          index: index,
          zoomEl: true,
          shareEl: false,
          fullscreenEl: false,
          arrowKeys: false,
          counterEl: false,
          showHideOpacity: true,
        };

        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
        atQuery('max', 'lg', () => {
          autoZoom(gallery);
          gallery.listen('afterChange', function() {autoZoom(gallery)});
        });
      });
    }
  });
}

function autoZoom(gallery) {
  gallery.zoomTo(.6, {x:200, y:0});
}
